import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-address-name',
  templateUrl: './address-name.component.html',
  styleUrl: './address-name.component.scss'
})
export class AddressNameComponent implements OnInit{
  @Input() data: any = undefined;
  @Input() column: any = undefined;

  constructor() {
  }

  ngOnInit() {
  }
}
